<form #form="ngForm">
    <div [ngSwitch]="activeProperty.uiControlType" class="mt-4">
        <h3>
            {{ 'MODULES.SPEC_GENERATION.WIDGET_DEMO' | translate }}
            <small class="mb-2">{{ 'MODULES.SPEC_GENERATION.WIDGET_DEMO_SUBCAPTION' | translate }}</small>
        </h3>
        <ng-container *ngSwitchCase="'slider'">
            <ca-slider
                name="slider"
                (onValueChange)="setSliderValue($event)"
                [step]="sliderStep"
                [minValue]="sliderMinValue"
                [maxValue]="sliderMaxValue"
                [value]="defaultValue"
            ></ca-slider>
            <div class="control-instruction font-s mb-1">{{ 'MODULES.SPEC_GENERATION.MIN_MAX_DESC' | translate }}</div>
        </ng-container>
        <ng-container *ngSwitchCase="'slider_range'">
            <ca-slider
                name="slider"
                [type]="'dual'"
                (onValueChange)="setRangeSliderValue($event)"
                [highSliderValue]="highSliderDefaultValue"
                [step]="sliderStep"
                [minValue]="sliderMinValue"
                [maxValue]="sliderMaxValue"
                [value]="defaultValue"
            ></ca-slider>
            <div class="control-instruction font-s mb-1">{{ 'MODULES.SPEC_GENERATION.RANGE_DESC' | translate }}</div>
        </ng-container>
        <ng-container *ngSwitchCase="'textbox'">
            <div *ngIf="activeProperty.specType === 'integer' || activeProperty.specType === 'number'" class="font-s mb-2">
                {{ 'MODULES.SPEC_GENERATION.MIN_MAX_OPTIONAL_DESC' | translate }}
            </div>
            <div *ngIf="activeProperty.specType === 'string'" class="control-instruction font-s mb-1">
                {{ 'MODULES.SPEC_GENERATION.INPUT_TEXT_DESC' | translate }}
            </div>
            <!-- for integers and numbers -->
            <input
                *ngIf="activeProperty.specType === 'integer'"
                [pattern]="integerPattern"
                digitOnly
                name="text"
                class="form-control"
                [(ngModel)]="defaultValue"
            />
            <input *ngIf="activeProperty.specType === 'number'" type="number" name="text" class="form-control" [(ngModel)]="defaultValue" />
            <!-- For text -->
            <input *ngIf="activeProperty.specType === 'string'" type="text" name="text" class="form-control" [value]="defaultValue" />
        </ng-container>
        <ca-input-checkbox *ngSwitchCase="'checkbox'" name="check" class="form-control" [(ngModel)]="defaultValue">{{
            activeProperty.uiProperty?.label
        }}</ca-input-checkbox>
        <ng-container *ngSwitchCase="'dropdown'">
            <ng-select
                placeholder="Preview : No default element selected"
                name="specPropertyDefault"
                [items]="getDropdownOrRadioItems()"
                [clearable]="false"
                [(ngModel)]="activeProperty.specProperty.default"
                [searchable]="false"
                data-uit="select-type"
                bindValue="key"
                bindLabel="label"
            >
            </ng-select>
        </ng-container>
        <ng-container *ngSwitchCase="'radiobuttongroup'">
            <div caGroup class="radio-group" [(ngModel)]="activeProperty.specProperty.default" name="currentProperty">
                <ca-input-radio *ngFor="let item of getDropdownOrRadioItems()" class="my-1" [name]="'module-parameters-radio'" [value]="item.key">
                    {{ item.label }}
                </ca-input-radio>
            </div>
        </ng-container>
    </div>
    <div *ngIf="isActivePropertyInput && ['number', 'integer', 'range'].includes(activeProperty.specType)" class="my-3">
        <div class="mb-2">{{ 'MODULES.SPEC_GENERATION.SET_PROPERTIES' | translate }}</div>
        <div class="d-flex justify-content-between">
            <div class="me-2 d-flex flex-column form-group">
                <label class="font-s d-block" for="minNumberInput">{{ 'MODULES.SPEC_GENERATION.MIN_VALUE' | translate }}<span class="red ps-1">*</span></label>
                <ng-container *ngIf="activeProperty.specType === 'integer'; then minIntegerInputTmpl; else minNumberInputTmpl"></ng-container>
            </div>
            <div class="d-flex flex-column form-group" *ngIf="activeProperty.specType !== 'range'">
                <label class="font-s d-block" for="defaultNumberInput"
                    >{{ 'MODULES.SPEC_GENERATION.DEFAULT_VALUE' | translate }}<span class="red ps-1">*</span></label
                >
                <ng-container *ngIf="activeProperty.specType === 'integer'; then defaultIntegerInputTmpl; else defaultNumberInputTmpl"> </ng-container>
            </div>
            <div class="ms-2 d-flex flex-column form-group">
                <label class="font-s d-block" for="sliderMaxValue">{{ 'MODULES.SPEC_GENERATION.MAX_VALUE' | translate }}<span class="red ps-1">*</span></label>
                <ng-container *ngIf="activeProperty.specType === 'integer'; then maxIntegerInputTmpl; else maxNumberInputTmpl"> </ng-container>
            </div>
        </div>
        <div *ngIf="activeProperty.specType === 'range'" class="d-flex justify-content-between mt-2">
            <div class="me-2 d-flex flex-column-reverse">
                <input
                    id="defaultNumberInput"
                    type="number"
                    name="defaultValue"
                    class="form-control"
                    [ngModel]="defaultValue"
                    (focusout)="setDefaultValueFromInput($event)"
                    required
                    [step]="sliderStep"
                />
                <label class="font-sm d-block" for="defaultNumberInput">Low {{ 'MODULES.SPEC_GENERATION.DEFAULT_VALUE' | translate }}</label>
            </div>
            <div class="ms-2 d-flex flex-column-reverse">
                <input
                    id="highSliderDefaultNumberInput"
                    type="number"
                    name="highSliderDefaultValue"
                    class="form-control"
                    [ngModel]="highSliderDefaultValue"
                    (focusout)="setHighSliderDefaultValueFromInput($event)"
                    required
                    [step]="sliderStep"
                />
                <label class="font-sm d-block" for="highSliderDefaultNumberInput">High {{ 'MODULES.SPEC_GENERATION.DEFAULT_VALUE' | translate }}</label>
            </div>
        </div>
        <div *ngIf="activeProperty?.uiControlType === 'slider' || activeProperty?.uiControlType === 'slider_range'" class="mt-2 d-flex flex-column-reverse">
            <ng-container *ngIf="activeProperty.specType === 'integer'; then stepSizeIntegerInputTmpl; else stepSizeNumberInputTmpl"></ng-container>
            <label for="sliderWidgetStep">{{ 'MODULES.SPEC_GENERATION.STEP_SIZE' | translate }}<span class="red ps-1">*</span></label>
        </div>
    </div>
</form>
<ng-template #minNumberInputTmpl>
    <input
        id="minNumberInput"
        type="number"
        name="min"
        class="form-control"
        #minRef="ngModel"
        [placeholder]="'MODULES.SPEC_GENERATION.MIN_VALUE' | translate"
        [ngModel]="sliderMinValue"
        required
        (focusout)="setMinValueFromInput($event)"
    />
    <ca-form-validation-error-presenter [validationErrors]="minRef.errors"></ca-form-validation-error-presenter>
</ng-template>
<ng-template #minIntegerInputTmpl>
    <input
        id="minNumberInput"
        [pattern]="integerPattern"
        digitOnly
        type="number"
        name="min"
        class="form-control"
        #minRef="ngModel"
        [placeholder]="'MODULES.SPEC_GENERATION.MIN_VALUE' | translate"
        [ngModel]="sliderMinValue"
        required
        (focusout)="setMinValueFromInput($event)"
    />
    <ca-form-validation-error-presenter [validationErrors]="minRef.errors"></ca-form-validation-error-presenter>
</ng-template>
<ng-template #defaultNumberInputTmpl>
    <input
        id="defaultNumberInput"
        type="number"
        name="defaultValue"
        class="form-control"
        [ngModel]="defaultValue"
        (focusout)="setDefaultValueFromInput($event)"
        [step]="sliderStep"
        required
        #defaultValueRef="ngModel"
    />
    <ca-form-validation-error-presenter [validationErrors]="defaultValueRef.errors"></ca-form-validation-error-presenter>
</ng-template>
<ng-template #defaultIntegerInputTmpl>
    <input
        id="defaultNumberInput"
        [pattern]="integerPattern"
        digitOnly
        type="number"
        name="defaultValue"
        class="form-control"
        [ngModel]="defaultValue"
        (focusout)="setDefaultValueFromInput($event)"
        [step]="sliderStep"
        required
        #defaultValueRef="ngModel"
    />
    <ca-form-validation-error-presenter [validationErrors]="defaultValueRef.errors"></ca-form-validation-error-presenter>
</ng-template>
<ng-template #maxNumberInputTmpl>
    <input
        id="sliderMaxValue"
        type="number"
        name="max"
        class="form-control"
        [ngModel]="sliderMaxValue"
        required
        [placeholder]="'MODULES.SPEC_GENERATION.MAX_VALUE' | translate"
        (focusout)="setMaxValueFromInput($event)"
        #maxRef="ngModel"
    />
    <ca-form-validation-error-presenter [validationErrors]="maxRef.errors"></ca-form-validation-error-presenter>
</ng-template>
<ng-template #maxIntegerInputTmpl>
    <input
        id="sliderMaxValue"
        [pattern]="integerPattern"
        digitOnly
        name="max"
        type="number"
        class="form-control"
        [ngModel]="sliderMaxValue"
        required
        [placeholder]="'MODULES.SPEC_GENERATION.MAX_VALUE' | translate"
        (focusout)="setMaxValueFromInput($event)"
        #maxRef="ngModel"
    />
    <ca-form-validation-error-presenter [validationErrors]="maxRef.errors"></ca-form-validation-error-presenter>
</ng-template>
<ng-template #stepSizeNumberInputTmpl>
    <input
        id="sliderWidgetStep"
        type="number"
        name="step"
        class="form-control step"
        required
        placeholder="Step size *"
        [ngModel]="sliderStep"
        required
        (focusout)="setSliderStepFromInput($event)"
        #stepRef="ngModel"
    />
    <ca-form-validation-error-presenter [validationErrors]="stepRef.errors"></ca-form-validation-error-presenter>
</ng-template>
<ng-template #stepSizeIntegerInputTmpl>
    <input
        type="number"
        id="sliderWidgetStep"
        [pattern]="integerPattern"
        digitOnly
        name="step"
        class="form-control step"
        required
        placeholder="Step size *"
        [ngModel]="sliderStep"
        required
        (focusout)="setSliderStepFromInput($event)"
        #stepRef="ngModel"
    />
    <ca-form-validation-error-presenter [validationErrors]="stepRef.errors"></ca-form-validation-error-presenter>
</ng-template>
